import {Component, ViewEncapsulation} from '@angular/core';
import {DevicesService, LoaderService, NavigateService} from 'ngx-satoris';
import {CartService} from '../../../shared/services/cart.service';
import {ApiService} from '../../../shared/services/api.service';
import {CurrencySign} from 'src/app/shared/models/request';

@Component({
  selector: 'app-means-payment',
  templateUrl: './means-payment.component.html',
  styleUrls: ['./means-payment.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MeansPaymentComponent {

  person: any;
  submitted = false;
  CurrencySign: any = CurrencySign;

  constructor(public nav: NavigateService, public cart: CartService, public api: ApiService, private loader: LoaderService, public device: DevicesService) {
    if(this.cart.selfiePerson) {
      this.cart.setStorageOLD({state: 'meansPayment'});
    } else {
      this.nav.to('camera-payment');
    }
  }

  payByPaypal() {
    this.loader.loading(true);
    if(this.cart.cartDatas.document_type !== 'preenroll'){
      this.loader.loading(true, {type: 'warn', message: 'pay.temp'}).then(() => {
        this.nav.to('document-management');
      });
    } else {
      if(this.api.isOnline && this.api.userInfo) {
        this.api.registerPaypalPayment(this.cart.cartDatas.document_type,
          +this.cart.actualPerson?.id,
          JSON.stringify({
            first_name: this.cart.actualPerson?.firstName,
            last_name: this.cart.actualPerson?.lastName,
            passport_number: this.cart.actualPerson?.passportNumber || undefined,
            national_number: this.cart.actualPerson?.nationalNumber || undefined,
            image: this.cart.selfiePerson
          })).then((res: any) => {
          this.loader.loading(false);

          window.sessionStorage.setItem('lastPaymentId', JSON.stringify(res?.id));
          window.open(res.link, '_self');
        }).catch((err) => {
          this.submitted = false;
          this.loader.loading(true, {type: 'error', message: err});
        });
      } else {
        this.loader.loading(true, {type: 'error', message: 'You need to be online to continue'});
      }
    }
  }
}
